import { TypographyProps } from 'Typography';

/*
  TODO: replace the `LabelType` keys with lowercase versions of themselves, that way this can be used as a type via `keyof typeof LabelType`.
  When the `Label` was initially built, the developer responsible capitalized the key names for whatever reason. This makes `keyof` fail, since the casing is different.
  Ive preserved the casing for now for backwards compatibility, but it should be updated as part of v2.
 */
export const LabelType = {
  Teammate: 'teammate',
  Secondary: 'secondary',
  Primary: 'primary',
  General: 'general',
  Business: 'business',
  Unsaved: 'unsaved',
  Work: 'work',
  Mobile: 'mobile',
  Home: 'home',
  Other: 'other',
} as const;

export type Variant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'subtitle1'
  | 'subtitle2'
  | 'body1'
  | 'body2'
  | 'caption'
  | 'button'
  | 'overline';
export interface StyledLabelProps extends TypographyProps {
  type?:
    | 'teammate'
    | 'secondary'
    | 'primary'
    | 'general'
    | 'business'
    | 'unsaved'
    | 'work'
    | 'mobile'
    | 'home'
    | 'other';
}
export interface LabelProps {
  type?:
    | 'teammate'
    | 'secondary'
    | 'primary'
    | 'general'
    | 'business'
    | 'unsaved'
    | 'work'
    | 'mobile'
    | 'home'
    | 'other';
  children?: string;
}
